import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/signaling",
    clipPath: "url(#clip_Signaling)"
  }, React.createElement("path", {
    id: "Rectangle 3581",
    d: "M4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8V12H4V8Z",
    fill: "currentColor"
  }), React.createElement("rect", {
    id: "Rectangle 3582",
    x: "1",
    y: "14",
    width: "14",
    height: "2",
    rx: "1",
    fill: "currentColor"
  }), React.createElement("rect", {
    id: "Rectangle 3583",
    x: "7",
    width: "2",
    height: "3",
    rx: "1",
    fill: "currentColor"
  }), React.createElement("rect", {
    id: "Rectangle 3584",
    x: "16",
    y: "7.5",
    width: "2",
    height: "3",
    rx: "1",
    transform: "rotate(90 16 7.5)",
    fill: "currentColor"
  }), React.createElement("rect", {
    id: "Rectangle 3585",
    x: "3",
    y: "7.5",
    width: "2",
    height: "3",
    rx: "1",
    transform: "rotate(90 3 7.5)",
    fill: "currentColor"
  }), React.createElement("rect", {
    id: "Rectangle 3586",
    x: "4.76758",
    y: "4.12134",
    width: "2",
    height: "3",
    rx: "1",
    transform: "rotate(135 4.76758 4.12134)",
    fill: "currentColor"
  }), React.createElement("rect", {
    id: "Rectangle 3587",
    width: "2",
    height: "3",
    rx: "1",
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 11.2324 4.12134)",
    fill: "currentColor"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Signaling16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Signaling16 = createIcon(IconComponent);